module.exports = __webpack_public_path__ + "img/001_thumbnail.f1629550.jpg";